import script from "./PropertiesAdvisorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertiesAdvisorComponent.vue?vue&type=script&setup=true&lang=js"

import "./PropertiesAdvisorComponent.vue?vue&type=style&index=0&id=557f052c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-557f052c"]])

export default __exports__